import {
  Button,
  OdinIcon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  TabView,
  TabViewPanel,
} from '@myosh/odin-components';
import { memo, useCallback, useRef, useState } from 'react';
import DisplayFilterTab, { type DisplayFilterTabRef } from './display-filter-tab.component';

function FilterOverlay() {
  const [isFilterOverlayOpen, setIsFilterOverlayOpen] = useState(false);

  const displayFilterTabRef = useRef<DisplayFilterTabRef>(null);

  const closeFilterOverlay = useCallback(() => {
    setIsFilterOverlayOpen(false);
  }, []);

  const handleSave = useCallback(() => {
    displayFilterTabRef.current?.save();
    closeFilterOverlay();
  }, []);

  return (
    <Popover open={isFilterOverlayOpen} onOpenChange={setIsFilterOverlayOpen}>
      <PopoverTrigger>
        <OdinIcon icon="Filter" className="size-5 text-primary hover:bg-accent rounded-md" />
      </PopoverTrigger>
      <PopoverContent align="start" data-cy="filter-overlay-panel">
        <TabView className="hover:text-primary text-muted-foreground mr-4 cursor-pointer" activeIndex={0}>
          <TabViewPanel header="Display">
            <DisplayFilterTab ref={displayFilterTabRef} />
          </TabViewPanel>
        </TabView>
        <Button data-cy="filter-overlay-apply-button" onClick={handleSave}>
          Apply
        </Button>
      </PopoverContent>
    </Popover>
  );
}

export default memo(FilterOverlay);
